// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ecommerce__account-select-dialog',
    // #endregion
    data: () => ({
        isLoading: false,
        accounts: []
    }),
    computed: {
        currentWindow() {
            return this.$utils.findVueComponent(this, ["g-modal-popup", "g-modal-slide"]);
        },
        accountID() {
            return this.$host.store.get("session").currentUser?.accountID;
        },
    },
    beforeMount() {
        this.loadData();
    },
    // #region Core
    methods: {
        async loadData() {
            this.isLoading = true;
            try {
                this.accounts = (await host.api.get('identity/accounts')).data;
            }
            catch {
                this.accounts = [];
            }
            this.isLoading = false;
        },
        async onSelect(account) {
            if (!account) {
                return;
            }
            //Set
            await this.$host.login.setAccount(account.accountID);
            //Close
            this.currentWindow.close();
        },
        onGotoAccount() {
            //Move
            this.$router.push('/service/accounts');
            //Close
            this.currentWindow.close();
        },
    },
    // #endregion
});
// #endregion
